export const sortByCreatedDate = <T extends { created_at: string }>(items: T[]): T[] =>
  items.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
